export const getContracts = (state) => state.contracts.list;
export const getSelection = (state) => state.contracts.selection;